import { Entity, Field } from 'typegraph';

import LaunchURL from 'common/entities/LaunchURL';
import { CreditEntry, CreditValid } from './CreditEntry';
import Entry from './Entry';
import { IssuedCertificate } from './IssuedCertificate';
import Product from './Product';

enum Completion {
	NotStarted = "NotStarted",
	Started = "Started",
	Incomplete = "Incomplete",
	Completed = "Completed",
	Passed = "Passed",
	Failed = "Failed"
}

enum Status {
	Active, Inactive, Expired, Deleted, Withdrawn, Candidate, Finished, Suspended
}

@Entity({
	one: "subscriptionUser",
	many: "subscriptionsUser"
})
export class Subscription {

	@Field()
	public id: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field()
	public timeSpent: number;

	@Field()
	public score: number;

	@Field()
	public completion: Completion;
	
	@Field()
	public completionPercentage: string;

	@Field()
	public completedOn: string;

	@Field()
	public status?: Status;

	@Field()
	public lastVisited?: string;

	@Field({entity: Product})
	public product: Product;

	@Field({entity: Entry})
	public entry: Entry;

	@Field({entity: IssuedCertificate})
	public certificates?: null | IssuedCertificate[];

	@Field({entity: CreditEntry})
	public credits?: null | CreditEntry[];

	@Field({entity: LaunchURL})
	public launchURL?: LaunchURL;

	@Field({entity: CreditValid})
	public validCredit?: CreditValid;

}



// WEBPACK FOOTER //
// ./src/panels/subscriptions/entities/Subscription.ts